// @flow
import React, {
  // $FlowFixMe
  useMemo,
  // $FlowFixMe
  useEffect,
  // $FlowFixMe
  useState,
  // $FlowFixMe
  forwardRef,
  // $FlowFixMe
  Ref,
  // $FlowFixMe
  ReactNode
} from "react";
import { get, noop, throttle } from "lodash";
import type { RaceWagerType } from "@tvg/types/Race";
import type { BinaryFn, UnaryFn } from "@tvg/types/Functional";
import { WagerTypesGroup } from "@fdr/types/WagerTypes";
import { isURP } from "@tvg/utils/generalUtils";

import WagerTypeSelector from "../../_molecules/WagerTypeSelector";
import ScrollWrapper from "../../_molecules/ScrollWrapper";
import { WagerTypesContainer, WagerTypesScroll } from "./styled-components";

type Props = {
  onWagerTypeClick: BinaryFn<RaceWagerType, number, void>,
  wagerTypes: RaceWagerType[],
  activeWagerType: number,
  withVideo: boolean,
  scrollEventCallBack: UnaryFn<number, void>,
  fixedOffset: number,
  country: string,
  showNameBetGroup: boolean,
  withFixedBanner?: boolean
};

const WagerSelector = forwardRef((props: Props, ref: Ref<ReactNode>) => {
  const {
    onWagerTypeClick,
    wagerTypes,
    activeWagerType,
    withVideo,
    fixedOffset,
    country,
    showNameBetGroup,
    withFixedBanner
  } = props;

  const shadowScrollYThreshold = 150;

  const [hasShadow, setHasShadow] = useState(false);
  useEffect(() => {
    const handleScroll = throttle(
      () => {
        setHasShadow(window.scrollY > shadowScrollYThreshold);
      },
      100,
      { trailing: true }
    );

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      handleScroll.cancel();
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return useMemo(
    () => (
      <WagerTypesContainer
        withVideo={withVideo}
        fixedOffset={fixedOffset}
        withFixedBanner={withFixedBanner}
        hasShadow={hasShadow}
        isURP={isURP}
      >
        <ScrollWrapper
          biggerFadding
          scrollEventCallBack={props.scrollEventCallBack}
        >
          <WagerTypesScroll ref={ref}>
            {wagerTypes.map((wagerType) => (
              <WagerTypeSelector
                key={`wager-type-${get(wagerType, "type.id")}`}
                wagerType={wagerType}
                country={country}
                onWagerTypeClick={onWagerTypeClick}
                activeWagerType={activeWagerType}
                showTypeName={
                  showNameBetGroup &&
                  WagerTypesGroup.WinPlaceShow.includes(wagerType.type.id)
                }
              />
            ))}
          </WagerTypesScroll>
        </ScrollWrapper>
      </WagerTypesContainer>
    ),
    [JSON.stringify(wagerTypes), activeWagerType, withVideo, hasShadow]
  );
});

WagerSelector.defaultProps = {
  onWagerTypeClick: noop,
  wagerTypes: [],
  country: "",
  activeWagerType: 0,
  withVideo: false,
  scrollEventCallBack: noop,
  fixedOffset: 48,
  showNameBetGroup: false
};

export default WagerSelector;
